module.exports = __webpack_public_path__ + "static/media/undraw_Delivery_re_f50b.3d448e8d.svg";